__turbopack_context__.v({
  "container": "zmLCfW_container",
  "discountPrice": "zmLCfW_discountPrice",
  "highlight": "zmLCfW_highlight",
  "highlightingContainer": "zmLCfW_highlightingContainer",
  "itemCost": "zmLCfW_itemCost",
  "itemDetailsContainer": "zmLCfW_itemDetailsContainer",
  "itemQuantity": "zmLCfW_itemQuantity",
  "noModifications": "zmLCfW_noModifications",
  "productNameContainer": "zmLCfW_productNameContainer",
  "quantityButton": "zmLCfW_quantityButton",
  "quantityText": "zmLCfW_quantityText",
  "selectedItemContainer": "zmLCfW_selectedItemContainer",
  "separator": "zmLCfW_separator",
});
